<script lang="tsx">
  import { Skeleton } from "primevue";
  import SingleLocationMap from "./SingleLocationMap.vue";

  export default {
    components: { Skeleton, SingleLocationMap },
    props: SingleLocationMap.props as (typeof SingleLocationMap["props"]),
  };
</script>

<template>
  <Suspense v-bind.attr="$attrs">
    <SingleLocationMap v-bind.attr="$attrs" v-bind.prop="$props as any"/>

    <template #fallback>
      <Skeleton width="100%" height="100%"/>
    </template>
  </Suspense>
</template>

<style lang="less">
</style>
